import { Button } from "antd";
import {
  additionalAmountStates,
  createPrxStates,
  handleStagesButtonText,
} from "containers/pmaOnboarding/services/data.transformers";
import { useTranslation } from "react-i18next";
import Rules from "components/rules";
import { ReactComponent as WarningInfo } from "assets/icons/warning-primary-circule.svg";

const OnbButton = ({
  currentStageDetails,
  disabled,
  planId,
  failed,
  loading = true,
  isFindAdditionalAmount,
  stepStage,
  onChangeRules,
  onClick,
  onRulesClick,
}) => {
  const { t } = useTranslation();

  const { isDone: createPrxIsDone, isStage: createPrxStage } =
    createPrxStates(currentStageDetails);

  const { isDone: additionalAmountIsDone, isStage: additionalAmountStage } =
    additionalAmountStates(currentStageDetails);

  const renderRules = () =>
    stepStage === 0 && (
      <Rules handleRulesClick={onRulesClick} onChangeRules={onChangeRules} />
    );

  const renderAdditionalAmountHelp = () =>
    additionalAmountStage &&
    !additionalAmountIsDone && (
      <div className="flex gap-1 items-center mb-3 text-gray-0 caption-12px-regular">
        <WarningInfo className="[&>path]:fill-warning-0" />
        {+planId === 3
          ? t("pma-onboarding.additional-amount-gold")
          : t("pma-onboarding.additional-amount-help")}
      </div>
    );

  const handleClassBtn = () => {
    if (
      createPrxIsDone ||
      (additionalAmountStage && additionalAmountIsDone) ||
      (createPrxStage && !isFindAdditionalAmount)
    )
      return "default-button-large";

    if (stepStage === 0 && !failed && disabled) return "disabled-button-large";
    return "primary-button-large";
  };

  return (
    <div className="p-5 fixed bottom-0 border-t bg-white border-gray--7 max-w-2xl w-full">
      {!failed && !loading && renderRules()}
      {renderAdditionalAmountHelp()}
      <Button
        block
        className={`${handleClassBtn()} min-h-[46px] justify-center items-center`}
        disabled={stepStage === 0 && !failed ? disabled : false}
        loading={loading}
        onClick={onClick}
      >
        {!loading &&
          handleStagesButtonText({
            additionalAmountIsDone,
            additionalAmountStage,
            createPrxIsDone,
            createPrxStage,
            failed,
            isFindAdditionalAmount,
            stepStage,
            t,
          })}
      </Button>
    </div>
  );
};
export default OnbButton;
